exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overlay[data-v-dcffa384] {\n  background-color: white;\n  min-width: 800px;\n  max-height: 800px;\n  padding: 1rem;\n  border-radius: 0.4rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);\n}\n.overlay .table[data-v-dcffa384] {\n  margin: 0;\n}\n.no-items[data-v-dcffa384] {\n  text-align: center;\n  padding: 2rem;\n}\n.xl-button[data-v-dcffa384] {\n  width: 45px;\n  height: 45px;\n}\n", ""]);

// exports
